'use client';

import * as Checkbox from '@radix-ui/react-checkbox';
import { twMerge } from 'tailwind-merge';

export type IndicatorProps = Checkbox.CheckboxIndicatorProps;

export function Indicator({ className, ...props }: IndicatorProps) {
  return (
    <Checkbox.Indicator
      className={twMerge([
        'flex size-5 items-center justify-center',
        'rounded-xs border border-slate-300 bg-white shadow-md',
        'transition-colors hover:bg-white/45',
        className,
      ])}
      {...props}
    />
  );
}
